// App.js (Homepage layout enhanced)

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import UgcNetRegistration from "./components/UgcNetRegistration";
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import Login from './components/Login';
import Register from './components/Register';
import EmployeeRegister from './components/EmployeeRegister';
import AboutInternship from './components/AboutInternship';
import ServiceDetail from './components/ServiceDetail';
import CTA from './components/CTA';
import EmployeeLogin from './components/EmployeeLogin';
import Appointment from './components/Appointment';
import LawAppointment from './components/LawAppointment';
import AstrologyAppointment from './components/AstrologyAppointment';
import CsProjectsAppointment from './components/CsProjectsAppointment';
import HomeopathyAppointment from './components/HomeopathyAppointment';
import CivilAppointment from './components/CivilAppointment';
import LawLogin from './components/LawLogin';
import AstroLogin from './components/AstroLogin';
import LawRegister from './components/LawRegister';
import ResearchAppointment from './components/ResearchAppointment';
import ThankYou from './components/ThankYou'; // adjust path if needed
import Failed from './components/Failed';
import UgcNetRegistrations from './components/UgcNetRegistrations';
import ResearchCourseDetails from './components/ResearchCourseDetails';
import PayIntern from './components/PayIntern';
import EmployeeDashboard from './components/EmployeeDashboard';
import InternDashboard from './components/InternDashboard';
import './App.css';

function AppContent() {
  const location = useLocation();

  const hideHeaderFooter = [
    '/login',
    '/register',
    '/employee-register',
    '/about-internship',
    '/login/law',
    '/login/astro',
    '/law-register', '/thank-you', '/failed', '/ugcnet-registrations',
    '/ugcnet-registration',
    '/research-course-details',
    '/pay-intern',
    '/employee-dashboard',
    '/dev-dashboard',
    '/intern-dashboard',
    '/dev-intern-dashboard'
  ].includes(location.pathname) || location.pathname.startsWith('/services/') || location.pathname.startsWith('/appointment/');

  return (
    <>
      {!hideHeaderFooter && <Header />}

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <div className="homepage-wrapper">
              <Hero />
              {/* <section className="homepage-section services-section">
                <Services />
              </section> */}
              <section className="homepage-section contact-section">
                <Contact />
              </section>

              <section className="homepage-section about-section">
                <About />
              </section>
            </div>
          }
        />

        {/* Auth Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/employee-register" element={<EmployeeRegister />} />
        <Route path="/login/law" element={<LawLogin />} />
        <Route path="/login/astro" element={<AstroLogin />} />
        <Route path="/law-register" element={<LawRegister />} />
        <Route path="/pay-intern" element={<PayIntern />} />
        {/* Service and Appointment */}
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/appointment/:serviceId" element={<Appointment />} />
        <Route path="/appointment/law" element={<LawAppointment />} />
        <Route path="/appointment/astrology" element={<AstrologyAppointment />} />
        <Route path="/appointment/cs-projects" element={<CsProjectsAppointment />} />
        <Route path="/appointment/homeopathy" element={<HomeopathyAppointment />} />
        <Route path="/appointment/civil" element={<CivilAppointment />} />
        <Route path="/employee-login/:serviceId" element={<EmployeeLogin />} />
        <Route path="/appointment/research" element={<ResearchAppointment />} />
        <Route path="/ugcnet-registrations" element={<UgcNetRegistrations />} />
        {/* Internship Page */}
        <Route path="/about-internship" element={<AboutInternship />} />

        {/* ✅ UGC NET Registration Page */}
        <Route path="/ugcnet-registration" element={<UgcNetRegistration />} />
        <Route path="/research-course-details" element={<ResearchCourseDetails />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/failed" element={<Failed />} />
        <Route path="/intern-dashboard" element={<InternDashboard />} />
        <Route path="/dev-intern-dashboard" element={<InternDashboard />} />
        <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        <Route path="/dev-dashboard" element={<EmployeeDashboard />} />
      </Routes>

      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
